module.exports = __webpack_public_path__ + "static/media/testImage11.e902fb0b.png";